export const FETCH_AUDIT_TRAILS_REQUEST_SUCCEED =
  'app/AuditTrail/FETCH_AUDIT_TRAILS_REQUEST_SUCCEED';
export const FETCH_CONSENT_FOR_AUDIT_TRAIL_REQUEST_SUCCEED =
  'app/AuditTrail/FETCH_CONSENT_FOR_AUDIT_TRAIL_REQUEST_SUCCEED';
